import { networkRequest } from "./core";

const API_URL = process.env.REACT_APP_API_BASE_URL;

const getActiveFundraisers = (role) => {
  let field;
  switch (role) {
    case "ADMIN":
      field = "ADMIN";
      break;
    case "GSA":
      field = "gsa_string";
      break;
    case "HERO":
      field = "fundraiser_hero_string";
      break;
    default:
      field = "";
      break;
  }
  return networkRequest
    .get(`${API_URL}/campaigns/getActiveCampaignsForDashBoard?field=${field}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return Promise.reject(error);
    });
};

const getAllFundraisers = (role) => {
  let field;
  switch (role) {
    case "ADMIN":
      field = "ADMIN";
      break;
    case "GSA":
      field = "gsa_string";
      break;
    case "HERO":
      field = "fundraiser_hero_string";
      break;
    default:
      field = "";
      break;
  }

  return networkRequest
    .get(`${API_URL}/campaigns/getCampaignsByField?field=${field}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return Promise.reject(error);
    });
};

const getAllProducts = () => {
  return networkRequest
    .get(`${API_URL}/campaigns/getAllProducts`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return Promise.reject(error);
    });
};

const getAllParticipantsByCampaignId = (id) => {
  return networkRequest
    .get(`${API_URL}/campaigns/getParticipantsByCampaignId?campaignId=${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return Promise.reject(error);
    });
};

const getSingleFundraiserDetails = (id) => {
  return networkRequest
    .get(`${API_URL}/public/campaigns/getSpecificCampaigns?id=${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return Promise.reject(error);
    });
};

const getParticipantLeaderboard = (id) => {
  return networkRequest
    .get(`${API_URL}/campaigns/leaderBoard/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return Promise.reject(error);
    });
};

const addFundraiser = (data) => {
  return networkRequest
    .post(`${API_URL}/campaigns/addCampaign`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return Promise.reject(error);
    });
};

const addMedia = (formData) => {
  return networkRequest
    .post(`${API_URL}/media/addMedia`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return Promise.reject(error);
    });
};

const updateFundraiser = (id, data) => {
  return networkRequest
    .put(`${API_URL}/campaigns/updateCampaign?id=${id}`, data)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return Promise.reject(error);
    });
};

const deleteFundraiser = (id) => {
  return networkRequest
    .delete(`${API_URL}/campaigns/deleteCampaign?id=${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return Promise.reject(error);
    });
};

const emailTrigger = (id) => {
  return networkRequest
    .post(`${API_URL}/trigger/email/campaign/${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      console.log(error);
      return Promise.reject(error);
    });
};

export const FundraiserServices = {
  getAllFundraisers,
  getActiveFundraisers,
  getAllProducts,
  getAllParticipantsByCampaignId,
  getSingleFundraiserDetails,
  getParticipantLeaderboard,
  addFundraiser,
  addMedia,
  updateFundraiser,
  deleteFundraiser,
  emailTrigger,
};
